import { render, staticRenderFns } from "./TipsWords.vue?vue&type=template&id=290e88ba&scoped=true"
import script from "./TipsWords.vue?vue&type=script&lang=js"
export * from "./TipsWords.vue?vue&type=script&lang=js"
import style0 from "./TipsWords.vue?vue&type=style&index=0&id=290e88ba&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e88ba",
  null
  
)

export default component.exports